import {
  FlattenedIssueTypeFilteringDtoOptions,
  FlattenedIssueTypes200Response,
  FlattenedIssueTypeSortingDtoOptions,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

export interface UseFlattenedIssueTypesParams {
  sort?: FlattenedIssueTypeSortingDtoOptions;
  filter?: FlattenedIssueTypeFilteringDtoOptions;
  page?: number;
  limit?: number;
}
export function useFlattenedIssueTypes(params: UseFlattenedIssueTypesParams) {
  const api = useApi();

  const { sort, filter, page = 0, limit = 10 } = params;

  return useQuery<FlattenedIssueTypes200Response, ExtendedAxiosError>({
    queryKey: ['flattened-issue-types', sort, filter, page, limit],
    queryFn: () =>
      api.flattenedIssueTypesApi
        .flattenedIssueTypes(sort, filter, page, limit)
        .then((r) => r.data),
    meta: {
      handleError: true,
    },
  });
}
